define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaNonpipedRegulationDomain = void 0;
    class WaNonpipedRegulationDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaNonpipedRegulationDomain.MinimumWaterHeight, value: "Minimum Water Height" },
                    { key: WaNonpipedRegulationDomain.MinimumVolume, value: "Minimum Volume" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaNonpipedRegulationDomain.MinimumWaterHeight] = 0;
                this.KeyIndex[WaNonpipedRegulationDomain.MinimumVolume] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Minimum Water Height"] = 0;
                this.ValueIndex["Minimum Volume"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaNonpipedRegulationDomain = WaNonpipedRegulationDomain;
    Object.defineProperty(WaNonpipedRegulationDomain, "MinimumWaterHeight", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaNonpipedRegulationDomain, "MinimumVolume", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaNonpipedRegulationDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
